module.exports = __webpack_public_path__ + "img/gov-sites.42324da0.svg";